import * as React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import Select from "components/common/Select";
import { defaultCompare } from "logic/DefaultCompare";
export const DEFAULT_STREAM_ID = "000000000000000000000001";
export const DEFAULT_SEARCH_ID = "DEFAULT_SEARCH";
const SelectContainer = styled.div`
  margin-bottom: 10px;
`;
const StreamSelect = ({ onChange, value, streams }) => {
  const { t } = useTranslation("configurations");
  const options = [
    { label: t("decorators_update.default_search"), value: DEFAULT_SEARCH_ID },
    ...streams.sort(({ title: key1 }, { title: key2 }) => defaultCompare(key1, key2)).map(({ title, id }) => ({ label: title, value: id }))
  ];
  return /* @__PURE__ */ React.createElement(SelectContainer, null, /* @__PURE__ */ React.createElement(
    Select,
    {
      inputId: "streams-filter",
      onChange,
      options,
      clearable: false,
      placeholder: t("decorators_update.no_decorators_placeholder"),
      value: options.map(({ value: id }) => id).includes(value) ? value : ""
    }
  ));
};
export default StreamSelect;
